import {
  AppliedCourseRes,
  Course,
  CourseApplicationPayload,
  CourseApplicationRes,
  CourseListResponse,
} from "@/store/types/courseTypes";
import axiosInstance from "@/utils/axiosInstance";
import { buildQueryString } from "@/utils/buildQueryString";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "../loader/loaderSlice";
import axios, { AxiosError } from "axios";

interface listPayload {
  universityId: string | number | undefined;
  filter?: { [keys: string]: string | number | boolean };
  sort?: { [key: string]: string | number | boolean };
}

export const getCourseList = createAsyncThunk<CourseListResponse, listPayload>(
  "course/getCourseList",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `university/courses/${payload.universityId}?filter=${buildQueryString(
          payload.filter ?? {}
        )}&sort=${buildQueryString(payload.sort ?? {})}`
      );
      return {
        list: data.courses,
        total: data.totalCount,
        all_course_level: data.all_course_level,
      };
    } catch (e) {
      console.error("Error while getting course list", e);
      return rejectWithValue(e);
    }
  }
);

export const getCourseDetail = createAsyncThunk<Course, number>(
  "course/getCourseDetail",

  async (payload, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    try {
      const { data } = await axiosInstance.get(`/courses/${payload}`);
      dispatch(stopLoading());
      return data;
    } catch (e) {
      dispatch(stopLoading());
      return rejectWithValue(e);
    }
  }
);
type ApplyForCourseError = {
  status: false;
  message: string;
};
export const applyForCourse = createAsyncThunk<
  CourseApplicationRes,
  CourseApplicationPayload,
  { rejectValue: ApplyForCourseError }
>("course/applyForCourse", async (payload, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post(
      `/student-applications/submit`,
      payload
    );
    return { status: true, message: data.message };
  } catch (err) {
    if (axios.isAxiosError(err)) {
      const error: AxiosError<{ message?: string }> = err;
      return rejectWithValue({
        status: false,
        message: error.response?.data?.message ?? "Something went wrong",
      });
    }
    return rejectWithValue({
      status: false,
      message: "Unexpected error",
    });
  }
});

export const getAppliedCourse = createAsyncThunk<AppliedCourseRes, string>(
  "course/getAppliedCourse",
  async (payload, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    try {
      const res = await axiosInstance.get(
        `/student-applications/getAppliedCourses/${payload}`
      );

      dispatch(stopLoading());
      return { data: res.data.data, status: true };
    } catch (e) {
      dispatch(stopLoading());
      return rejectWithValue(e);
    }
  }
);
